import React, { useEffect, useState } from "react";
import { Dropdown, DropdownMenu, DropdownToggle, Form } from "reactstrap";
import SearchOption from "../../../Components/Common/SearchOption";
import FullScreenDropdown from "../../../Components/Common/FullScreenDropdown";
import ProfileDropdown from "../../../Components/Common/ProfileDropdown";

import { useSelector, useDispatch } from "react-redux";
import { DownCarrot, RedBall, UpCarrot } from "../../../assets/images/svg/svg";
import "./Header.scss";
import { getSwitchDropdown, sidebarList } from "../../../Utils/CommonService";
import { Link, useNavigate } from "react-router-dom";
import { getRoleList } from "../../../pages/Settings/UserManagement/Roles/RolesService";
import { getRoles } from "../../../pages/Settings/UserManagement/Users/UserService";
import {
  setDrodownData,
  setSelectedUser,
} from "../../../slices/header/headerSlice";
import { getEntityId, getEntityType } from "../../../Utils/CommonUtils";
import { getData } from "../../../pages/Hub/Information/InformationService";

const DropdownItemList = ({
  item,
  providerName,
  index,
  onClick,
  isSelected,
}) => {
  const truncateText = (text, maxLength) => {
    if (text?.length <= maxLength) {
      return text;
    }
    return `${text?.substring(0, maxLength)}...`;
  };

  return (
    <div
      className={`dropdown-item-list-main-container ${
        isSelected ? "selected-item" : ""
      }`}
      onClick={() => onClick(item, providerName)}
    >
      <div className="d-flex align-item-center gap-3 position-relative">
        <div
          className="dropdown-container-name"
          style={{ background: `${index === 0 ? "#E8CCF5" : "#BDBEC2"}` }}
        >
          <span style={{ color: `${index === 0 ? "#573E6B" : "#0A0B0D"}` }}>
            {/* {item.name[0]} */}
            {item.name ? item.name[0] : ""}
          </span>
        </div>
        <div className="d-flex flex-column dropdown-sidename-container">
          <span className="dropdown-t1" title={item.name}>
            {truncateText(item.name, 25)}
          </span>
          <span className="dropdown-t2" title={item.buss_category}>
            {item.code} - {truncateText(item.buss_category, 25)}
          </span>
        </div>
      </div>
    </div>
  );
};

const Header = ({ headerClass }) => {
  const [search, setSearch] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const dispatch = useDispatch();
  const dropdownData = useSelector((state) => state.header.dropdownData);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const nav = useNavigate();
  const triggerRender = useSelector((state) => state.common.triggerRender);

  const agsaOrgId = useSelector((state) => state.header.agsaOrgId);
  const pspOrgId = useSelector((state) => state.header.pspOrgId);
  const agOrgId = useSelector((state) => state.header.agOrgId);
  const agsaEntityType = useSelector((state) => state.header.agsaEntityType);
  const pspEntityType = useSelector((state) => state.header.pspEntityType);
  const agEntityType = useSelector((state) => state.header.agEntityType);
  const usersFieldJson = useSelector((state) => state.users.usersFieldJson);

  const validDropdownData = Object.keys(dropdownData || {}).filter(
    (key) => dropdownData[key] !== null && dropdownData[key].length > 0
  );

  const truncateText = (text, maxLength) => {
    if (text?.length <= maxLength) {
      return text;
    }
    return `${text?.substring(0, maxLength)}...`;
  };

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("selectedUser"));
    if (storedUser) {
      dispatch(setSelectedUser(storedUser));
    }
  }, [dispatch]);

  // Persist selectedUser to localStorage when it changes
  useEffect(() => {
    localStorage.setItem("selectedUser", JSON.stringify(selectedUser));
  }, [selectedUser]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getSwitchDropdown();
        const validKeys = Object.keys(response).filter(
          (key) => response[key] !== null && response[key].length > 0
        );

        if (
          validKeys.length > 0 &&
          !JSON.parse(localStorage.getItem("selectedUser"))?.name
        ) {
          const firstKey = validKeys[0];

          dispatch(
            setSelectedUser({
              name: response[firstKey][0].name,
              providerName: firstKey,
              service: response[firstKey][0].service,
              buss_category: response[firstKey][0].buss_category,
              code: firstKey.code,
              entityid: response[firstKey][0].entityid,
              entitytype: response[firstKey][0].entitytype,
              organizationid: response[firstKey][0].organizationid,
              owner_id: response[firstKey][0].owner_id,
              organization_type: response[firstKey][0].organization_type,
              agsa_icon_media_url: response[firstKey][0].agsa_icon_media_url,
            })
          );
          dispatch(setDrodownData(response));
        }
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
    };

    fetchData();
  }, [dispatch, selectedUser]);

  const toggleDropdown = () => {
    setDropdown(!dropdown);
  };

  const toogleSearch = () => {
    setSearch(!search);
  };

  const handleItemClick = (item, providerName) => {
    if (providerName === "PSP" || providerName === "AG") {
      nav("/hub/information");
      // nav("/");
    }
    if (providerName === "AGSA") {
      // nav("/hub/information");
      nav("/hub/information");
    }
    dispatch(
      setSelectedUser({
        name: item.name,
        providerName: providerName,
        service: item.service,
        buss_category: item.buss_category,
        code: item.code,
        entityid: item.entityid,
        entitytype: item.entitytype,
        organizationid: item.organizationid,
        owner_id: item.owner_id,
        organization_type: item.organization_type,
        agsa_icon_media_url: item.agsa_icon_media_url,
      })
    );

    // let organizationId;
    // let entityType;
    // if (providerName === "PSP") {
    //   organizationId = pspOrgId;
    //   entityType = pspEntityType;
    // } else if (providerName === "AG") {
    //   organizationId = agOrgId;
    //   entityType = agEntityType;
    // } else if (providerName === "AGSA") {
    //   organizationId = agsaOrgId;
    //   entityType = agsaEntityType;
    // }
    // sidebarList(providerName, organizationId);
    setDropdown(false);
    // getRoleList(organizationId, entityType);
    // getRoles(organizationId, entityType, usersFieldJson);
  };

  const handleViewAllClick = (providerName, event) => {
    event.preventDefault();

    switch (providerName) {
      case "PSP":
        nav(`/psp/psp`);
        break;
      case "AG":
        nav(`/ag/ag`);
        break;
      case "AGSA":
        nav(`/ag-list`);
        break;
      default:
        break;
    }
    setDropdown(false);
  };
  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex header">
              <div className="d-flex flex-column header-heading-main-div">
                <Dropdown
                  isOpen={dropdown}
                  toggle={toggleDropdown}
                  className="dropdown-main-container"
                >
                  <DropdownToggle>
                    <div className="d-flex flex-row gap-3 ">
                      <span
                        className="header-heading-t-1"
                        title={selectedUser?.name}
                      >
                        {/* {selectedUser?.name ||
                          (dropdownData &&
                            validDropdownData.length > 0 &&
                            dropdownData[validDropdownData[0]][0]?.name) ||
                          ""} */}
                        {truncateText(
                          selectedUser?.name ||
                            (dropdownData &&
                              validDropdownData.length > 0 &&
                              dropdownData[validDropdownData[0]][0]?.name) ||
                            "",
                          15
                        )}
                      </span>
                      <span>{dropdown ? <UpCarrot /> : <DownCarrot />}</span>
                    </div>
                  </DropdownToggle>
                  <DropdownMenu className="dropdownmenu-container">
                    <div className="dropdown-top-bar"></div>
                    <div className="dropdown-list">
                      {validDropdownData.map((providerName, index) => (
                        <div key={providerName}>
                          {index > 0 && (
                            <div className="dropdown-divider"></div>
                          )}
                          {index === 0 ? (
                            <div>
                              <span className="gb-t1"></span>
                            </div>
                          ) : (
                            <div className="d-flex align-item-center justify-content-between grey-box">
                              <div>
                                <span className="gb-t1">
                                  {providerName.toLocaleUpperCase()} (
                                  {dropdownData[providerName]?.length})
                                </span>
                              </div>
                              {/* {index !== 0 && (
                                <span
                                  className="gb-t2"
                                  onClick={(event) =>
                                    handleViewAllClick(providerName, event)
                                  }
                                >
                                  View All
                                </span>
                              )} */}
                              {dropdownData[providerName]?.length > 2 &&
                                selectedUser.providerName === "AGSA" && (
                                  <span
                                    className="gb-t2"
                                    onClick={(event) =>
                                      handleViewAllClick(providerName, event)
                                    }
                                  >
                                    View All
                                  </span>
                                )}
                            </div>
                          )}
                          {dropdownData[providerName]
                            ?.slice(0, 2)
                            .map((item, innerIndex) => (
                              <DropdownItemList
                                key={`${providerName}-${innerIndex}`}
                                item={item}
                                providerName={providerName}
                                index={innerIndex}
                                onClick={handleItemClick}
                                isSelected={
                                  selectedUser?.name === item.name &&
                                  selectedUser?.providerName === providerName
                                }
                              />
                            ))}
                        </div>
                      ))}
                    </div>
                  </DropdownMenu>
                </Dropdown>

                <span className="header-t-2" title={selectedUser.buss_category}>
                  {selectedUser.code ||
                    (validDropdownData.length > 0 &&
                      dropdownData[validDropdownData[0]][0]?.code)}
                  -{" "}
                  {selectedUser.buss_category ||
                    (validDropdownData.length > 0 &&
                      dropdownData[validDropdownData[0]][0]?.buss_category)}
                </span>
              </div>

              {/* <SearchOption /> */}
            </div>

            <div className="d-flex align-items-center">
              <Dropdown
                isOpen={search}
                toggle={toogleSearch}
                className="d-md-none topbar-head-dropdown header-item"
              >
                <DropdownToggle
                  type="button"
                  tag="button"
                  className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                >
                  <i className="bx bx-search fs-22"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                  <Form className="p-3">
                    <div className="form-group m-0">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search ..."
                          aria-label="Recipient's username"
                        />
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify"></i>
                        </button>
                      </div>
                    </div>
                  </Form>
                </DropdownMenu>
              </Dropdown>

              <FullScreenDropdown />
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
